import styled from "styled-components"

import AnimatedWindowProvider from "context/window/AnimatedWindowProvider"

import useFetchProductDetail from "hooks/product/useFetchProductDetail"

import ProductDetailHeader from "components/presenters/commerce/product/ProductDetailHeader"
import ProductDetailContainer from "components/containers/commerce/product/ProductDetailContainer"
import AchievementContainer from "components/containers/commerce/product/AchievementContainer"

export default function ProductDetailLayout({ productNo, currNavTab }) {
  const { isLoading, isEnd } = useFetchProductDetail(productNo)

  if (isLoading || !isEnd) return null
  return (
    <AnimatedWindowProvider>
      <ProductDetailSection>
        <ProductDetailHeader />
        <ProdDetailWrapper>
          {currNavTab === "info" ? (
            <ProductDetailContainer />
          ) : (
            <AchievementContainer productNo={productNo} />
          )}
        </ProdDetailWrapper>
      </ProductDetailSection>
    </AnimatedWindowProvider>
  )
}

const ProductDetailSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`

const ProdDetailWrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
`
